import telemetry from "@/utils/telemetry";

/**
 * Helper functions for My List actions (add/remove content with telemetry)
 */

export function toggleMyListItem(
  content: any,
  contentType: string,
  {
    inMyList,
    addContentToMyList,
    removeContentFromMyList,
    route,
  }: {
    inMyList: (content: any) => boolean;
    addContentToMyList: (payload: any) => void;
    removeContentFromMyList: (payload: any) => void;
    route: any;
  }
) {
  if (inMyList(content)) {
    removeContentFromMyList({
      routeName: route.name,
      result: content,
    });
  } else {
    addContentToMyList({
      routeName: route.name,
      result: content,
    });
    trackAddToList(route, content, contentType);
  }
}

export function trackAddToList(route: any, content: any, type: string) {
  telemetry.add_to_list(
    "add-contentType-to-list",
    route.fullPath,
    type,
    content.title || content.name || "",
    content.id
  );
}
